import React from 'react';
import c from 'classnames';
import s from './RootLayout.scss';
var RootLayout = function (_a) {
    var prefix = _a.prefix, left = _a.left, right = _a.right, className = _a.className;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement("div", { className: s['left-with-prefix'] },
            prefix && React.createElement("div", { className: s['prefix'] }, prefix),
            left && React.createElement("div", { className: s['left'] }, left)),
        right && React.createElement("div", { className: s['right'] }, right)));
};
RootLayout.displayName = 'RootLayout';
export default RootLayout;
//# sourceMappingURL=RootLayout.js.map